var _path, _g, _path2, _g2, _path3, _path4, _mask, _path5, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgPropsPrimary = function SvgImgPropsPrimary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 23,
    viewBox: "0 0 67 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5102_160182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_160182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95633 7.53C2.54005 6.86395 3.0189 6 3.80433 6H19.0001V21C19.0001 21.5523 18.5524 22 18.0001 22H3.80433C3.0189 22 2.54006 21.136 2.95634 20.47L7.00009 14L2.95633 7.53Z",
    fill: "#631FB7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_160182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 6V5.25H19.0001H3.80433C2.42982 5.25 1.59185 6.76191 2.32034 7.9275L6.11565 14L2.32034 20.0725C1.59185 21.2381 2.42982 22.75 3.80433 22.75H18.0001C18.9666 22.75 19.7501 21.9665 19.7501 21V6Z",
    fill: "#631FB7",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18L19 22V18H13Z",
    fill: "#A27AD5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5102_160182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 6,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0437 7.53C64.4599 6.86395 63.9811 6 63.1957 6H47.9999V21C47.9999 21.5523 48.4476 22 48.9999 22H63.1957C63.9811 22 64.4599 21.136 64.0437 20.47L59.9999 14L64.0437 7.53Z",
    fill: "#631FB7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5102_160182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2499 6V5.25H47.9999H63.1957C64.5702 5.25 65.4082 6.76191 64.6797 7.9275L60.8843 14L64.6797 20.0725C65.4082 21.2381 64.5702 22.75 63.1957 22.75H48.9999C48.0334 22.75 47.2499 21.9665 47.2499 21V6Z",
    fill: "#631FB7",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 18L48 22V18H54Z",
    fill: "#A27AD5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2C13 1.44772 13.4477 1 14 1H53C53.5523 1 54 1.44772 54 2V18H13V2Z",
    fill: "#753BBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6504 13.869H31.4184V8.952H30.5494V13.418H29.3394V4.244H30.5494V7.929H31.4184V4.068H32.6504V13.869ZM25.8854 10.492C26.8864 10.525 28.0634 10.437 28.7234 10.272L28.8444 11.284C28.1074 11.482 26.6664 11.548 25.5334 11.548H24.5984V5.234H28.3054V6.257C27.5024 6.257 26.6994 6.246 25.8854 6.246V10.492ZM42.685 12.637H33.83V11.625H35.997V9.733H37.284V11.625H39.198V9.733H40.474V11.625H42.685V12.637ZM41.827 9.271H34.644V8.248H35.997L35.81 6.4L37.097 6.268L37.207 8.248H39.341L39.605 6.29L40.848 6.477L40.54 8.248H41.827V9.271ZM41.849 5.817H34.622V4.794H41.849V5.817Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-1_5102_160182",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 65,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: -1,
    width: 65,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1973 1C13.645 1 13.1973 1.44772 13.1973 2V6H4.0016C3.21616 6 2.73732 6.86395 3.1536 7.53L7.19735 14L3.1536 20.47C2.73732 21.136 3.21616 22 4.0016 22H18.1974C18.7496 22 19.1974 21.5523 19.1974 21V18H48.1972V21C48.1972 21.5523 48.6449 22 49.1972 22H63.3929C64.1784 22 64.6572 21.136 64.2409 20.47L60.1972 14L64.2409 7.53C64.6572 6.86395 64.1784 6 63.3929 6H54.1973V2C54.1973 1.44772 53.7495 1 53.1973 1H14.1973Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1973 6V7.5H14.6973V6H13.1973ZM3.1536 7.53L1.8816 8.325L3.1536 7.53ZM7.19735 14L8.46935 14.795L8.96622 14L8.46935 13.205L7.19735 14ZM3.1536 20.47L1.8816 19.675L3.1536 20.47ZM19.1974 18V16.5H17.6974V18H19.1974ZM48.1972 18H49.6972V16.5H48.1972V18ZM64.2409 20.47L62.9689 21.265L62.9689 21.265L64.2409 20.47ZM60.1972 14L58.9252 13.205L58.4283 14L58.9252 14.795L60.1972 14ZM64.2409 7.53L65.5129 8.325V8.325L64.2409 7.53ZM54.1973 6H52.6973V7.5H54.1973V6ZM14.6973 2C14.6973 2.27614 14.4734 2.5 14.1973 2.5V-0.5C12.8166 -0.5 11.6973 0.619288 11.6973 2H14.6973ZM14.6973 6V2H11.6973V6H14.6973ZM13.1973 4.5H4.0016V7.5H13.1973V4.5ZM4.0016 4.5C2.03801 4.5 0.840902 6.65987 1.8816 8.325L4.4256 6.735C4.63374 7.06803 4.39432 7.5 4.0016 7.5V4.5ZM1.8816 8.325L5.92535 14.795L8.46935 13.205L4.4256 6.735L1.8816 8.325ZM5.92535 13.205L1.8816 19.675L4.4256 21.265L8.46935 14.795L5.92535 13.205ZM1.8816 19.675C0.840904 21.3401 2.03801 23.5 4.0016 23.5V20.5C4.39432 20.5 4.63374 20.932 4.4256 21.265L1.8816 19.675ZM4.0016 23.5H18.1974V20.5H4.0016V23.5ZM18.1974 23.5C19.5781 23.5 20.6974 22.3807 20.6974 21H17.6974C17.6974 20.7239 17.9212 20.5 18.1974 20.5V23.5ZM20.6974 21V18H17.6974V21H20.6974ZM48.1972 16.5H19.1974V19.5H48.1972V16.5ZM46.6972 18V21H49.6972V18H46.6972ZM46.6972 21C46.6972 22.3807 47.8165 23.5 49.1972 23.5V20.5C49.4733 20.5 49.6972 20.7239 49.6972 21H46.6972ZM49.1972 23.5H63.3929V20.5H49.1972V23.5ZM63.3929 23.5C65.3565 23.5 66.5536 21.3401 65.5129 19.675L62.9689 21.265C62.7608 20.932 63.0002 20.5 63.3929 20.5V23.5ZM65.5129 19.675L61.4692 13.205L58.9252 14.795L62.9689 21.265L65.5129 19.675ZM61.4692 14.795L65.5129 8.325L62.9689 6.735L58.9252 13.205L61.4692 14.795ZM65.5129 8.325C66.5536 6.65987 65.3565 4.5 63.3929 4.5V7.5C63.0002 7.5 62.7608 7.06803 62.9689 6.735L65.5129 8.325ZM63.3929 4.5H54.1973V7.5H63.3929V4.5ZM52.6973 2V6H55.6973V2H52.6973ZM53.1973 2.5C52.9211 2.5 52.6973 2.27614 52.6973 2H55.6973C55.6973 0.619288 54.578 -0.5 53.1973 -0.5V2.5ZM14.1973 2.5H53.1973V-0.5H14.1973V2.5Z",
    fill: "white",
    mask: "url(#path-9-outside-1_5102_160182)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5102_160182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 23,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgPropsPrimary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_props_primary.c5ed01a4.svg";
export { ForwardRef as ReactComponent };